import React, { useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/directors-message-banner.png';
import '../styles/pages.css';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';

function DirectorMessage() {

    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Message From The Director</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            We Look Forward to Continuing a Better Service Upholding the 
                            <br/>
                            Values of Our Hospital - Love, Kindness and Service.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            We Look Forward to Continuing a Better Service Upholding the Values of Our Hospital - Love, Kindness and Service.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="director-box-content">
                            <p className="director-box-name">Rev. Fr. Dr. Binu Kunnath</p>

                            <p className="director-positions">Director, Caritas Hospital</p>
                            <br/>

                            <p className="social-media-content">
                                Connect with
                                <br/>
                                Rev. Fr. Dr. Binu Kunnath on Social Media Channels
                            </p>

                            <div className='director-social-media'>
                                
                                <a href="https://www.linkedin.com/in/fr-dr-binu-kunnath-a56605181/" target="_blank">
                                    <FaLinkedin />
                                </a>
                                <a href="https://www.facebook.com/people/Fr-Dr-Binu-Kunnath/61553804964105/?mibextid=qi2Omg" target="_blank">
                                    <FaFacebook />
                                </a>
                                <a href="https://www.instagram.com/frdrbinukunnath/?igsh=MTF6NzJhbTBxbnFwOA%3D%3D" target="_blank">
                                    <FaInstagram />
                                </a>
                            </div>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Directors Message Banner" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='director-page-content'>
                    <div className='page-details'>
                        <p className='page-content-heading'>Welcome to Caritas Matha Hospital!</p>
                        <br/>

                        <p>Caritas Hospital came into being when few visionaries collectively envisioned providing specialized and affordable medical care to people of all walks of life in and around Kottayam. Our vision is to extend hospital ministry with an emphasis on compassionate service. From its humble beginning in 1962, Caritas Hospital has emerged as one of the leading health care providers in Kerala. Over the years, from a 50 bedded hospital, Caritas has grown to a 655 bedded hospital. We expand our facilities from time to time catering to the increasing needs of our patients.</p>
                        <br/>

                        <p>Hospital is committed to delivering the best medical care. The meticulous services of our Medical, Administrative and Support staff ensure world class healthcare. Our highly qualified team of expert doctors spread over 33 departments offer the best care to patients. Modern technology is an integral part of today’s medical care. Caritas Hospital has been pioneers in introducing some of the modern technology to patient care in the central region of Kerala. In Caritas, we have state –of –the-art medical equipment and the most modern technology. Hence, at every stage of patient care, Caritas makes sure that each and every patient receives the optimum care.</p>
                        <br/>

                        <p>Caritas Hospital is enthusiastic about fulfilling the lofty vision of its founding fathers in providing high quality healthcare. The management and the patrons of the hospital played a vital role in maintaining quality care and competence. Their commitment and constant encouragement helped us reach the present stage. We look forward to continuing a better service upholding the values of our Hospital – Love, Kindness and Service. Our mantra, “Kenotic Love Saves Life” equips each Caritasian to share the goal of providing a comprehensive patient care and spread the radiance of Good Health and Happiness.</p>
                        <br/>
                        
                        <p>Wishing good health to all!</p>
                        <br/>

                        <p className='director-name'>
                            Rev. Fr. Dr. Binu Kunnath
                            <br/>
                            Director, Caritas Hospital 
                        </p>

                    </div>
                
                    <br/>
                    <br/>
                </div>

                <div className="message-container">
                    <p className='director-message'>
                        We look forward to <br/>
                        continuing a better<br/>
                        service upholding<br/>
                        the values of our <br/>
                        Hospital - <span>Love, <br/>
                        Kindness and <br/>
                        Service.</span>
                    </p>
                </div>
            </section>


            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default DirectorMessage;